import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {UserSummary} from '../../../../../account/modules/user/api/entity/userSummary.model';
import {Moment} from 'moment';

export class SaleRetrocessionSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    user: UserSummary;
    balance: number;
    date: Moment;
    turnover: number;
    id: number;
}

